export const isDisplayBlock = (
	startDate?: string | null,
	endDate?: string | null
): boolean => {
	const now = new Date();

	if (!startDate && !endDate) {
		return true;
	}

	if (!startDate && endDate) {
		const end = new Date(endDate);
		return now <= end;
	}

	if (startDate && endDate) {
		const start = new Date(startDate);
		const end = new Date(endDate);
		return now >= start && now <= end;
	}

	if (startDate && !endDate) {
		const start = new Date(startDate);
		return now >= start;
	}

	return true;
};
